import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  container: {
    minHeight: '100vh',
  },
}))
